module.exports = __webpack_public_path__ + "static/img/partner_5.7c8876c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/partners/partner_5.png
// module id = nWZc
// module chunks = 0